import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import { CompanySmsSendingRuleAutoClaimBase } from "@/souhl_admin/gql/__generated__/graphql"
import { formatJstDateUntilDayByHyphen } from "@/utils/date"

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/

const companySmsSendingRuleAutoClaimBaseLabel = {
	RESERVATION_RECEIPTED_DATE: "RESERVATION_RECEIPTED_DATE",
	CANCEL_DATE: "CANCEL_DATE",
} as const

const companySmsSendingRuleAutoClaimBaseLabelKeys = Object.keys(
	companySmsSendingRuleAutoClaimBaseLabel
).map((key) => key as CompanySmsSendingRuleAutoClaimBase)

const normalizeOptionalDateInput = (value: string | null): string | null =>
	value === "" ? null : value

export const smsSendingStartSettingsSchema = yup.object({
	autoClaimBase: yup
		.mixed<CompanySmsSendingRuleAutoClaimBase>()
		.oneOf(companySmsSendingRuleAutoClaimBaseLabelKeys)
		.default(
			companySmsSendingRuleAutoClaimBaseLabel.RESERVATION_RECEIPTED_DATE
		),
	enableAutoClaimStartDate: yup.boolean().default(true),
	autoClaimStartDate: yup
		.string()
		.nullable()
		.transform(normalizeOptionalDateInput)
		.default(formatJstDateUntilDayByHyphen(new Date()))
		.when("enableAutoClaimStartDate", {
			is: true,
			then: (schema) =>
				schema
					.required("請求開始日は必須です")
					.matches(DATE_REGEX, "請求開始日は YYYY-MM-DD形式で入力してください"),
			otherwise: (schema) => schema.nullable().notRequired(),
		}),
	enableEncourageStartCancelDate: yup.boolean().default(true),
	encourageStartCancelDate: yup
		.string()
		.nullable()
		.transform(normalizeOptionalDateInput)
		.default(formatJstDateUntilDayByHyphen(new Date()))
		.when("enableEncourageStartCancelDate", {
			is: true,
			then: (schema) =>
				schema
					.required("再予約開始日は必須です")
					.matches(
						DATE_REGEX,
						"再予約開始日は YYYY-MM-DD形式で入力してください"
					),
			otherwise: (schema) => schema.nullable().notRequired(),
		}),
})

export type SmsSendingStartSettingsForm = yup.InferType<
	typeof smsSendingStartSettingsSchema
>

export const smsSendingStartSettingsResolver = yupResolver(
	smsSendingStartSettingsSchema
)
